import { UseInfiniteQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { CursorPaginated, CursorPaginationParams } from 'types/pagination';
import { LumeoEvent } from 'types/event';
import { UseEventsParams } from 'events/hooks/useEvents';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedInfiniteQuery } from 'hooks/api/useAuthenticatedQuery';

type UseInfiniteEventsOptions = UseInfiniteQueryOptions<
  CursorPaginated<LumeoEvent>,
  APIError
> & {
  params?: UseEventsParams & CursorPaginationParams;
};

export function useInfiniteEvents({
  queryKey = ['events'],
  params,
  ...options
}: UseInfiniteEventsOptions = {}) {
  const { applicationID, client } = useAPI();

  const queryParams = { limit: 50, ...params, pagination: 'cursor' };

  return useAuthenticatedInfiniteQuery(
    [...queryKey, applicationID, queryParams],
    async ({ pageParam = null }) => {
      const { data } = await client.get<CursorPaginated<LumeoEvent>>(
        `/apps/${applicationID}/events`,
        {
          params: {
            ...queryParams,
            next_cursor: pageParam,
          },
        }
      );

      return data;
    },
    {
      ...options,
      getNextPageParam: ({ next_cursor }) => next_cursor,
      getPreviousPageParam: ({ prev_cursor }) => prev_cursor,
    }
  );
}
